import { render, staticRenderFns } from "./AiBookOrder.vue?vue&type=template&id=487ab740&scoped=true"
import script from "./AiBookOrder.vue?vue&type=script&lang=js"
export * from "./AiBookOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ab740",
  null
  
)

export default component.exports